import Line from "../objects/Line";
import AnnotationDefault from "../objects/AnnotationDefault";

let objectTemplates = {
    "line": Line
};

export default class ChartDrawObjectProvider {
    static draw(config, objectConfigs, annotationConfig = AnnotationDefault) {

        for (let objectConfig in objectConfigs) {
            if (objectTemplates.hasOwnProperty(objectConfig)){

                let object = objectTemplates[objectConfig];
                for (let objectKeys in objectConfigs[objectConfig] ) {
                    object[objectKeys] = objectConfigs[objectConfig][objectKeys];
                }

                annotationConfig.annotations.push(object)
            }
        }

        config.options['annotation'] = annotationConfig;

        return config;
    }

}


// WEBPACK FOOTER //
// ./src/components/chart/data/ChartDrawObjectProvider.js